<template>
    <div class="commissions-mensuelles">
        <template v-if="isClientMonthlyPayment">
            <div class="row">
                <div class="col-12">
                    <div class="page__head-title page__head-title--orange">
                        <div class="page__head-title__text page__head-title__text--orange">Commissions</div>
                    </div>
                </div>
                <div class="col-12">
                    <div class="form_ttl_first">
                        Informations sur vos commissions :
                    </div>
                </div>
                <div class="col-12">
                    <div class="block__content--table">
                        <table>
                            <thead>
                                <tr>
                                    <th>Garantie</th>
                                    <th>Quantité</th>
                                    <th>Commissions Totales</th>
                                    <th>Commissions en Réserve</th>
                                    <th>Commissions Disponibles</th>
                                </tr>
                            </thead>
                            <tbody>
                                <template v-for="garantie in garanties">
                                    <tr v-if="garantie.show">
                                        <td>{{ garantie.title }}</td>
                                        <td>{{ garantie.qty }}</td>
                                        <td :class="garantie.total < 0 ? 'text-danger' : ''">{{ garantie.total |
                                            formatEURWithoutSymbol | formatSeparateComma}} €</td>
                                        <td :class="garantie.reserved < 0 ? 'text-danger' : ''">{{ garantie.reserved |
                                            formatEURWithoutSymbol | formatSeparateComma}} €</td>
                                        <td :class="garantie.available < 0 ? 'text-danger' : ''">{{ garantie.available |
                                            formatEURWithoutSymbol | formatSeparateComma}} €</td>
                                    </tr>
                                </template>
                                <tr v-if="reglementTotal.show">
                                    <td>Règlement Commissions</td>
                                    <td>{{ reglementTotal.qty }}</td>
                                    <td :class="reglementTotal.total > 0 ? 'text-danger' : ''">{{ reglementTotal.total >
                                        0 ? '-' :
                                        ''}}{{ reglementTotal.total | formatEURWithoutSymbol | formatSeparateComma }} €
                                    </td>
                                    <td :class="reglementTotal.reserved > 0 ? 'text-danger' : ''">
                                        {{ reglementTotal.reserved > 0 ? '-' :
                                        ''}}{{ reglementTotal.reserved | formatEURWithoutSymbol | formatSeparateComma }} €
                                    </td>
                                    <td :class="reglementTotal.available > 0 ? 'text-danger' : ''">
                                        {{ reglementTotal.available > 0 ? '-' :
                                        ''}}{{ reglementTotal.available | formatEURWithoutSymbol | formatSeparateComma }}
                                        €</td>
                                </tr>
                                <tr>
                                    <td><b>Total</b></td>
                                    <td><b>{{ garantiesTotal.qty }}</b></td>
                                    <td :class="garantiesTotal.total < 0 ? 'text-danger' : ''"><b>{{ garantiesTotal.total
                                        | formatEURWithoutSymbol |
                                            formatSeparateComma}} €</b></td>
                                    <td :class="garantiesTotal.reserved < 0 ? 'text-danger' : ''">
                                        <b>{{ garantiesTotal.reserved | formatEURWithoutSymbol
                                            | formatSeparateComma}} €</b></td>
                                    <td :class="garantiesTotal.available < 0 ? 'text-danger' : ''">
                                        <b>{{ garantiesTotal.available |
                                            formatEURWithoutSymbol | formatSeparateComma}} €</b></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="col-12">
                    <div class="block__content--chart">
                        <div class="row">
                            <div class="col-12 col-sm-6">
                                <div class="dougnhut-chart-wrapper">
                                    <div class="dougnhut-chart-wrapper__center-text">
                                        <p class="dougnhut-chart-wrapper__center-text--count">{{ garantiesTotal.total |
                                            formatEURWithoutSymbol | formatSeparateComma}} €</p>
                                        <p class="dougnhut-chart-wrapper__center-text--title">Total</p>
                                    </div>
                                    <canvas id="account-quotes-doughnut-chart" width="300px" height="300px"></canvas>
                                </div>
                            </div>
                            <div class="col-12 col-sm-6">
                                <div class="assets-list">
                                    <!-- <template v-for="garantie in garanties">
                                        <div class="assets-list__item" v-if="garantie.show">
                                            <div class="assets-list__item--percentage">{{garantie.qty}}</div>
                                            <div class="assets-list__item--title">{{garantie.title}}</div>
                                            <div class="assets-list__item--border" v-bind:style="{backgroundColor: garantie.color}"></div>
                                            <div class="assets-list__item--data">{{garantie.total | formatEURWithoutSymbol | formatSeparateComma}} €</div>
                                        </div>
                                    </template>
                                    <div class="assets-list__item" v-if="reglementTotal.show">
                                        <div class="assets-list__item--percentage">{{reglementTotal.qty}}</div>
                                        <div class="assets-list__item--title">{{reglementTotal.title}}</div>
                                        <div class="assets-list__item--border" v-bind:style="{backgroundColor: reglementTotal.color}"></div>
                                        <div class="assets-list__item--data">{{reglementTotal.total > 0 ? '-' : ''}}{{reglementTotal.total | formatEURWithoutSymbol | formatSeparateComma}} €</div>
                                    </div> -->
                                    <div class="assets-list__item">
                                        <div class="assets-list__item--title">Commissions en Réserve</div>
                                        <div class="assets-list__item--border"
                                            v-bind:style="{ backgroundColor: '#ff6d00' }"></div>
                                        <div class="assets-list__item--data">{{ garantiesTotal.reserved |
                                            formatEURWithoutSymbol |
                                            formatSeparateComma}} €</div>
                                    </div>
                                    <div class="assets-list__item">
                                        <div class="assets-list__item--title">Commissions Disponibles</div>
                                        <div class="assets-list__item--border"
                                            v-bind:style="{ backgroundColor: '#008cc9' }"></div>
                                        <div class="assets-list__item--data">{{ garantiesTotal.available |
                                            formatEURWithoutSymbol |
                                            formatSeparateComma}} €</div>
                                    </div>
                                </div>
                                <div class="col-12 mt-3 mb-5 text-center">
                                    <button class="btn button blue text-uppercase virement-button"
                                        @click.prevent="requestWire" :disabled="sending"
                                        v-if="balances.available >= 300">
                                        <span class="vb-icon d-none">
                                            <svg width="24" height="24" viewBox="0 0 50 50"
                                                xmlns="http://www.w3.org/2000/svg" aria-label="Loading" role="img">
                                                <circle cx="25" cy="25" r="20" fill="none" stroke="currentColor"
                                                    stroke-width="6" stroke-linecap="round" stroke-dasharray="90 150"
                                                    transform="rotate(-90 25 25)">
                                                    <animateTransform attributeName="transform" type="rotate"
                                                        from="0 25 25" to="360 25 25" dur="1s"
                                                        repeatCount="indefinite" />
                                                </circle>
                                            </svg>
                                        </span>
                                        <span class="vb-text">Virement de mes commissions</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12">
                    <div class="form_ttl_first">
                        Bordereaux de commissions :
                    </div>
                </div>
                <div class="col-12">
                    <CommissionsCustomFilter :filters="filtersC" @filter="handleFilterC" />
                    <template v-if="isBusyC">
                        <Preloader />
                    </template>
                    <template v-else>
                        <template v-if="commissions.data.length > 0">
                            <div class="clients__table mb-3">
                                <div class="clients__table__item">
                                    <div class="clients__table__item--cell">Date</div>
                                    <div class="clients__table__item--cell small_wider">N° de Bordereau</div>
                                    <div class="clients__table__item--cell">Montant</div>
                                    <div class="clients__table__item--cell icon-cell">Bordereau</div>
                                </div>
                                <div class="clients__table__item" v-for='commission in commissions.data'>
                                    <div class="clients__table__item--cell">{{ parseDate(commission.created_at) }}</div>
                                    <div class="clients__table__item--cell small_wider">{{ commission.commission_number }}
                                    </div>
                                    <div class="clients__table__item--cell">{{ parseFloat(commission.amount).toFixed(2) }}
                                        €</div>
                                    <div class="clients__table__item--cell icon-cell">
                                        <font-awesome-icon prefix="fas" icon="file-pdf"
                                            @click="show_pdf(commission.id)" />
                                    </div>
                                </div>
                            </div>
                            <pagination :data="commissions" @pagination-change-page="getCommissions" />
                        </template>
                        <template v-else>
                            <div class="subscribes-empty">Il n'y a aucun bordereau de commission à ce jour.</div>
                        </template>
                    </template>
                </div>
                <div class="col-12">
                    <div class="form_ttl_first">
                        Demandes de commissions :
                    </div>
                </div>
                <div class="col-12">
                    <CommissionsCustomFilter :filters="filtersR" @filter="handleFilterR" />
                    <template v-if="isBusyR">
                        <Preloader />
                    </template>
                    <template v-else>
                        <template v-if="requests.data.length > 0">
                            <div class="clients__table mb-3">
                                <div class="clients__table__item">
                                    <div class="clients__table__item--cell">N°</div>
                                    <!-- <div class="clients__table__item--cell" style="width:145px;">Statut</div> -->
                                    <div class="clients__table__item--cell">Montant</div>
                                    <div class="clients__table__item--cell">Date</div>
                                    <!-- <div class="clients__table__item--cell">Note</div> -->
                                </div>
                                <div class="clients__table__item" v-for='request in requests.data'>
                                    <div class="clients__table__item--cell">3609000{{ request.id }}</div>
                                    <!-- <div class="clients__table__item--cell" style="width:145px;">{{parseMqcRequestStatus(request.status)}}</div> -->
                                    <div class="clients__table__item--cell">{{ parseFloat(request.amount).toFixed(2) }} €
                                    </div>
                                    <div class="clients__table__item--cell">{{ parseDate(request.created_at) }}</div>
                                    <!-- <div class="clients__table__item--cell notes-cell">
                                        <div class="reqNote-container">
                                            <span class="reqNote">{{request.notes}}</span>
                                            <div class="reqNote-tooltip">{{request.notes}}</div>
                                        </div>
                                    </div> -->
                                </div>
                            </div>
                            <pagination :data="requests" @pagination-change-page="getRequests" />
                        </template>
                        <template v-else>
                            <div class="subscribes-empty">Il n'y a aucune demande de commission à ce jour.</div>
                        </template>
                    </template>
                </div>
                <div class="col-12 mt-5" v-if="false"> <!-- Previous v-if: balances.available >= 300 -->
                    <div style="text-align:center;">
                        <button class="btn button blue text-uppercase" @click.prevent="requestPayment">
                            Demander le règlement de commissions
                        </button>
                    </div>
                </div>
                <!-- <div class="col-12 mt-5" v-if="balances.available >= 300">
                    <div style="text-align:center;">
                        <button class="btn button blue text-uppercase" @click.prevent="requestWire">
                            Virement de mes commissions
                        </button>
                    </div>
                </div> -->
            </div>
            <template v-if="false"> <!-- Previous v-if: balances.available >= 300 -->
                <commissionsMensuellesDemanderReglementModal :balances="balances" v-show="demanderReglementModal"
                    @close="closeDemanderReglementModal" @refresh-requests="refreshRequests"
                    ref="demanderReglementModalRef" />
            </template>
            <!-- <button class="btn button blue text-uppercase virement-button" @click.prevent="requestWire" :disabled="sending" v-if="balances.available >= 300">
                <span class="vb-icon d-none">
                    <svg
                        width="24" height="24" viewBox="0 0 50 50"
                        xmlns="http://www.w3.org/2000/svg" aria-label="Loading" role="img">
                        <circle
                            cx="25" cy="25" r="20"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="6"
                            stroke-linecap="round"
                            stroke-dasharray="90 150"
                            transform="rotate(-90 25 25)">
                            <animateTransform
                                attributeName="transform"
                                type="rotate"
                                from="0 25 25"
                                to="360 25 25"
                                dur="1s"
                                repeatCount="indefinite" />
                        </circle>
                    </svg>
                </span>
                <span class="vb-text">Virement de mes commissions</span>
            </button> -->
        </template>
        <template v-else>
            <div class="row">
                <div class="col-12">
                    <div class="page__head-title page__head-title--orange">
                        <div class="page__head-title__text page__head-title__text--orange">Commissions</div>
                    </div>
                </div>
                <div class="col-12 mt-5 mb-5" style="font-size: 18px; color: #888; font-weight: 500;">Cette page n'est
                    pas disponible pour vous.</div>
            </div>
        </template>
    </div>
</template>

<script>
import Preloader from '@/components/Preloader';
import CommissionsCustomFilter from '@/components/Commissions/CommissionsCustomFilter';
import commissionsMensuellesDemanderReglementModal from '@/components/Commissions/CommissionsMensuellesDemanderReglementModal';
export default {
    name: 'CommissionsMensuelles',
    components: { Preloader, CommissionsCustomFilter, commissionsMensuellesDemanderReglementModal },
    data() {
        return {
            sending: false,
            isBusyC: false,
            isBusyR: false,
            demanderReglementModal: false,
            demanderReglementModalRef: null,
            filtersC: {
                start_date: null,
                end_date: null,
                amount: ''
            },
            filtersR: {
                start_date: null,
                end_date: null,
                amount: ''
            },
            commissions: {
                data: []
            },
            requests: {
                data: []
            },
            doughnutChart: null,
            balances: {
                total: 0,
                reserved: 0,
                available: 0
            },
            garanties: [
                {
                    title: "Garantie Auto 12 Mois",
                    color: '#008cc9',
                    show: false,
                    qty: 0,
                    total: 0,
                    available: 0,
                    reserved: 0
                },
                {
                    title: "Garantie Auto 24 Mois",
                    color: '#ffc500',
                    show: false,
                    qty: 0,
                    total: 0,
                    available: 0,
                    reserved: 0
                },
                {
                    title: "Garantie Auto 36 Mois",
                    color: '#ff6d00',
                    show: false,
                    qty: 0,
                    total: 0,
                    available: 0,
                    reserved: 0
                },
                {
                    title: "Garantie Auto 48 Mois",
                    color: '#28a745',
                    show: false,
                    qty: 0,
                    total: 0,
                    available: 0,
                    reserved: 0
                }
            ],
            reglementTotal: {
                title: "Règlement Commissions",
                color: "#ff0000",
                show: false,
                qty: 0,
                total: 0,
                available: 0,
                reserved: 0
            },
            garantiesTotal: {
                qty: 0,
                total: 0,
                available: 0,
                reserved: 0
            }
        }
    },
    computed: {
        isClientMonthlyPayment() {
            return this.$store.getters.isClientMonthlyPayment;
        },
        mechanic() {
            return this.$store.getters.getMechanic;
        }
    },
    methods: {
        drawAccountQuotesDoughnutChart() {
            let doughnutChartContainer = document.getElementById('account-quotes-doughnut-chart'),
                data = [],
                backgroundColor = [],
                labels = [];
            // for (let i in this.garanties) {
            //     data.push(this.garanties[i].total);
            //     backgroundColor.push(this.garanties[i].color);
            //     labels.push(this.garanties[i].title);
            // }
            // if(this.reglementTotal.show) {
            //     data.push(-1 * this.reglementTotal.total);
            //     backgroundColor.push(this.reglementTotal.color);
            //     labels.push(this.reglementTotal.title);
            // }
            data.push(this.garantiesTotal.reserved);
            data.push(this.garantiesTotal.available);
            backgroundColor.push('#ff6d00');
            backgroundColor.push('#008cc9');
            labels.push('Commissions en Réserve');
            labels.push('Commissions Disponibles');
            if (this.doughnutChart) {
                this.doughnutChart.destroy();
            }
            this.doughnutChart = new Chart(doughnutChartContainer, {
                type: 'doughnut',
                data: {
                    datasets: [{
                        data,
                        backgroundColor,
                        borderColor: 'transparent',
                    }],
                    labels
                },
                options: {
                    animation: false,
                    responsive: false,
                    maintainAspectRatio: false,
                    legend: {
                        display: false
                    },
                    tooltips: {
                        callbacks: {
                            label: (tooltipItem, data) => {
                                let value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index],
                                    currency = data.labels[tooltipItem.index];
                                return currency + ': ' + this.replaceDotCommaAmount(value) + ' €';
                            }
                        },
                        backgroundColor: 'rgba(0,0,0,1)'
                    }
                }
            });
        },
        getCommissions(page = 1) {
            this.isBusyC = true;
            if (this.mechanic && this.mechanic.id) {
                let params = this.parseFilterC(page);
                this.apiGet(`${this.mechanic.id}/commissions-mensuelles/payments`, params)
                    .then(response => {
                        if (response.data && response.data.status === 'success') {
                            this.commissions = response.data.results;
                            this.isBusyC = false;
                        }
                    })
                    .catch(error => this.showErrorNotification(error));
            }
        },
        getRequests(page = 1) {
            this.isBusyR = true;
            if (this.mechanic && this.mechanic.id) {
                let params = this.parseFilterR(page);
                this.apiGet(`${this.mechanic.id}/commissions-mensuelles/payment-requests`, params)
                    .then(response => {
                        if (response.data && response.data.status === 'success') {
                            this.requests = response.data.results;
                            this.isBusyR = false;
                        }
                    })
                    .catch(error => {
                        this.isBusyR = false;
                        this.showErrorNotification(error);
                    });
            }
        },
        parseDate(date) {
            return this.moment(date).format('DD/MM/YYYY');
        },
        show_pdf(id) {
            this.refreshTokenForce()
                .then(() => window.location = this.getApiAuthUrl(`commissions/pdf/${id}`))
                .catch(error => this.showErrorNotification(error));
        },
        parseFilterC(page = 1) {
            let data = {};
            if (this.filtersC.start_date) {
                data.start_date = this.filtersC.start_date;
                data.start_date.setHours(0, 0, 0, 0);
            }
            if (this.filtersC.end_date) {
                data.end_date = this.filtersC.end_date;
                data.end_date.setHours(23, 59, 59, 0);
            }
            if (this.filtersC.amount) data.amount = this.filtersC.amount;
            data.page = page;

            return data;
        },
        parseFilterR(page = 1) {
            let data = {};
            if (this.filtersR.start_date) {
                data.start_date = this.filtersR.start_date;
                data.start_date.setHours(0, 0, 0, 0);
            }
            if (this.filtersR.end_date) {
                data.end_date = this.filtersR.end_date;
                data.end_date.setHours(23, 59, 59, 0);
            }
            if (this.filtersR.amount) data.amount = this.filtersR.amount;
            data.page = page;

            return data;
        },
        requestPayment() {
            this.$refs.demanderReglementModalRef.resetForm();
            this.demanderReglementModal = true;
        },
        closeDemanderReglementModal() {
            this.demanderReglementModal = false;
        },
        handleFilterC(filters) {
            this.filtersC = { ...filters };
            this.getCommissions();
        },
        handleFilterR(filters) {
            this.filtersR = { ...filters };
            this.getRequests();
        },
        parseMqcRequestStatus(status) {
            switch (status) {
                case 'pending':
                    return 'En attente de validation';
                case 'approved':
                    return 'Demande acceptée';
                case 'rejected':
                    return 'Demande refusée';
                default:
                    return 'Statut inconnu';
            }
        },
        refreshRequests() {
            this.getRequests();
        },
        refreshCommissions() {
            this.getCommissions();
        },
        getCommissionsStatsData() {
            this.apiGet(`${this.mechanic.id}/commissions-mensuelles`)
                .then(response => {
                    if (response.data && response.data.status === 'success') {
                        if (response.data.month12) {
                            this.garanties[0].show = response.data.month12.show;
                            this.garanties[0].qty = parseInt(response.data.month12.qty);
                            this.garanties[0].total = parseFloat(response.data.month12.total).toFixed(2);
                            this.garanties[0].available = parseFloat(response.data.month12.available).toFixed(2);
                            this.garanties[0].reserved = parseFloat(response.data.month12.reserved).toFixed(2);
                        }
                        if (response.data.month24) {
                            this.garanties[1].show = response.data.month24.show;
                            this.garanties[1].qty = parseInt(response.data.month24.qty);
                            this.garanties[1].total = parseFloat(response.data.month24.total).toFixed(2);
                            this.garanties[1].available = parseFloat(response.data.month24.available).toFixed(2);
                            this.garanties[1].reserved = parseFloat(response.data.month24.reserved).toFixed(2);
                        }
                        if (response.data.month36) {
                            this.garanties[2].show = response.data.month36.show;
                            this.garanties[2].qty = parseInt(response.data.month36.qty);
                            this.garanties[2].total = parseFloat(response.data.month36.total).toFixed(2);
                            this.garanties[2].available = parseFloat(response.data.month36.available).toFixed(2);
                            this.garanties[2].reserved = parseFloat(response.data.month36.reserved).toFixed(2);
                        }
                        if (response.data.month48) {
                            this.garanties[3].show = response.data.month48.show;
                            this.garanties[3].qty = parseInt(response.data.month48.qty);
                            this.garanties[3].total = parseFloat(response.data.month48.total).toFixed(2);
                            this.garanties[3].available = parseFloat(response.data.month48.available).toFixed(2);
                            this.garanties[3].reserved = parseFloat(response.data.month48.reserved).toFixed(2);
                        }
                        if (response.data.reglement) {
                            this.reglementTotal.show = response.data.reglement.show;
                            this.reglementTotal.qty = parseInt(response.data.reglement.qty);
                            this.reglementTotal.total = parseFloat(response.data.reglement.total).toFixed(2);
                            this.reglementTotal.available = parseFloat(response.data.reglement.available).toFixed(2);
                            this.reglementTotal.reserved = parseFloat(response.data.reglement.reserved).toFixed(2);
                        }
                        if (response.data.total) {
                            this.garantiesTotal.qty = parseInt(response.data.total.qty);
                            this.garantiesTotal.total = parseFloat(response.data.total.total).toFixed(2);
                            this.garantiesTotal.available = parseFloat(response.data.total.available).toFixed(2);
                            this.garantiesTotal.reserved = parseFloat(response.data.total.reserved).toFixed(2);
                        }
                    }
                    this.drawAccountQuotesDoughnutChart();
                })
                .catch(error => {
                    this.showErrorNotification(error);
                });
        },
        requestWire() {
            this.sending = true;
            this.toggleVirementButtonLoader(true);
            let url = `${this.mechanic.id}/commissions-mensuelles/wire-request`;
            this.apiPost(url, {})
                .then((response) => {
                    this.sending = false;
                    this.toggleVirementButtonLoader(false);
                    if (response.data && response.data.status === 'success') {
                        this.refreshRequests();
                        this.refreshCommissions();
                        this.getCommissionsStatsData();
                        if (response.data.available || response.data.available == 0) {
                            this.$store.state.userInfo.mechanic.mqc_balance_available = response.data.available;
                        }
                        if (response.data.reserved || response.data.reserved == 0) {
                            this.$store.state.userInfo.mechanic.mqc_balance_reserved = response.data.reserved;
                        }
                        this.showSuccessNotification("Le virement a été demandé avec succès.");
                    } else if (response.data && response.data.status === 'error') {
                        if (response.data.message) {
                            this.showErrorNotification(response.data.message);
                        } else {
                            this.showErrorNotification("Impossible de créer la virement de commission.");
                        }
                    } else {
                        this.showErrorNotification("Une erreur est survenue.");
                    }
                })
                .catch(error => {
                    this.showErrorNotification(error);
                    this.toggleVirementButtonLoader(false);
                });
        },
        toggleVirementButtonLoader(on = false) {
            let vb = document.querySelectorAll('.virement-button');
            if (on) {
                vb.forEach((button) => {
                    button.querySelector('.vb-icon').classList.remove('d-none');
                    button.querySelector('.vb-text').classList.add('d-none');
                });
            } else {
                vb.forEach((button) => {
                    button.querySelector('.vb-icon').classList.add('d-none');
                    button.querySelector('.vb-text').classList.remove('d-none');
                });
            }
        },
        refreshBalances() {
            this.balances.reserved = this.$store.state.userInfo.mechanic && this.$store.state.userInfo.mechanic.mqc_balance_reserved ? parseFloat(this.$store.state.userInfo.mechanic.mqc_balance_reserved).toFixed(2) : 0.00;
            this.balances.available = this.$store.state.userInfo.mechanic && this.$store.state.userInfo.mechanic.mqc_balance_available ? parseFloat(this.$store.state.userInfo.mechanic.mqc_balance_available).toFixed(2) : 0.00;
            this.balances.total = Number(this.balances.reserved) + Number(this.balances.available);
        }
    },
    mounted() {
        if (this.$store.getters.isClientMonthlyPayment) {
            this.refreshBalances();
        }
        if (this.mechanic && this.mechanic.id) {
            this.getCommissions();
            this.getRequests();

            this.getCommissionsStatsData();
        } else {
            this.showWarningNotification('Mechanic ID not found');
        }
    },
    watch: {
        '$store.state.userInfo.mechanic.mqc_balance_reserved': function () {
            this.refreshBalances();
            this.refreshRequests();
            this.refreshCommissions();
            this.getCommissionsStatsData();
        },
        '$store.state.userInfo.mechanic.mqc_balance_available': function () {
            this.refreshBalances();
            this.refreshRequests();
            this.refreshCommissions();
            this.getCommissionsStatsData();
        }
    }
}
</script>

<style scoped>
.notes-cell {
    position: relative;
    overflow: visible !important;
}

.reqNote-container {
    position: relative;
    display: inline-block;
    width: 100%;
}

.reqNote {
    display: inline-block;
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    vertical-align: middle;
    position: relative;
    cursor: pointer;
}

.reqNote-tooltip {
    visibility: hidden;
    position: absolute;
    z-index: 1000;
    min-width: 200px;
    max-width: 400px;
    background-color: #333;
    color: #fff;
    text-align: center;
    border-radius: 4px;
    padding: 5px 10px;
    bottom: 100%;
    left: 0;
    margin-bottom: 5px;
    opacity: 0;
    transition: opacity 0.3s;
    white-space: normal;
    word-wrap: break-word;
    font-size: 14px;
}

.reqNote-tooltip::after {
    content: "";
    position: absolute;
    top: 100%;
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: #333 transparent transparent transparent;
}

.reqNote:hover+.reqNote-tooltip {
    visibility: visible;
    opacity: 1;
}

/*.virement-button {
    position: fixed !important;
    bottom: 50px;
    right: 50px;
    z-index: 1;
    border: 1px solid #fff !important;
}*/
</style>



// WEBPACK FOOTER //
// src/components/Commissions/CommissionsMensuelles.vue